<template>
<section>
  <section class="imgs_box">
    <img v-for="(item,index) in imgs" :key="item.path" @click="viewImgs(index)" :src="item.path">
  </section>
  <!-- 查看大图 -->
  <fade-animation>
    <common-gallary
      :imgs="newImgs"
      v-show="showGallary"
      @close="showGallary = false"
      :curIndex="curIndex"
    ></common-gallary>
  </fade-animation>
</section>
</template>

<script>
import CommonGallary from '../components/Gallary'
import FadeAnimation from '../components/FadeAnimation'
import storage from '../utils/storage'
export default {
  name: 'viewImgs',
  components: {
    CommonGallary,
    FadeAnimation
  },
  data(){
    return {
      imgs:[],
      showGallary:false,
      curIndex:0,
      newImgs:[]
    }
  },
  methods: {
    btnClick(){
      if(!this.canClick){
        return;
      }
      this.$emit("btnClick")
    },
    viewImgs(index){
      this.curIndex = index;
      this.showGallary = true;
    }
  },
  created(){
    let fileList = JSON.parse(storage.get("imgs"));
    console.log(fileList)
    this.imgs = fileList;
    let newL = [];
    fileList.forEach(item=>{
      newL.push(item.path)
    })
    this.newImgs = newL;
  },
  beforeDestroy(){
    storage.remove("imgs")
  }
}
</script>

<style scoped lang="less">
@import "../assets/css/common.less";
.imgs_box{
  .flex();
  flex-wrap: wrap;
  margin-top:20px;
  img{
    width:224px;
    height:224px;
    margin-bottom:20px;
    margin-left:20px;
    background:#EBEBEB;
  }
}
</style>
